import styles from '../DealerLocator.module.scss';
import cx from 'classnames';

export interface DealerLocatorFiltersServiceOfferingsProps {
  title: string;
  children?: React.ReactNode;
}

export const DealerLocatorFiltersServiceOfferings = ({
  title,
  children
}: DealerLocatorFiltersServiceOfferingsProps) => {
  return (
    <div>
      <p
        className={cx(
          styles['dealer-locator-text'],
          'cat-u-theme-typography-label-lg mb-0'
        )}
      >
        {title}
      </p>
      {children}
    </div>
  );
};
